import React, { useMemo } from 'react';
import { IState } from '@/state/IState';
import { useSelector } from 'react-redux';
import { ExtractProps, ProjectFeature, ProjectFeatureMode } from '@/types';
import { Trans } from '@lingui/react/macro';
import { CommentThread } from '@ygtechnologies/bygr-frontend-chat';
import { CommentThreadWrapper } from '@/components/Comments/CommentThreadWrapper';

// interface BuyerCommentsWrapperProps {}
type BuyerCommentsWrapperProps = Omit<ExtractProps<typeof CommentThread>, 'profileId' | 'readOnly'>;
const BuyerChat: React.FC<BuyerCommentsWrapperProps> = ({ ...rest }) => {
    const projectData = useSelector((state: IState) => state.buyer.projectData);
    const permissions = useSelector((state: IState) => state.buyer.permissions);

    const isReadOnly = !permissions?.canModify;
    const showReadOnlyMessage = !!projectData?.isInReadOnlyMode;

    const disableDocumentAccess = !projectData?.features?.some(
        (x) => x.feature === ProjectFeature.Documents && x.mode === ProjectFeatureMode.Enabled
    );

    const warnings = useMemo(() => {
        if (showReadOnlyMessage) {
            return [<Trans>This unit is in read only mode.</Trans>];
        }

        return [];
    }, [showReadOnlyMessage]);

    return (
        <CommentThreadWrapper
            variant="buyer"
            disableDocumentAccess={disableDocumentAccess}
            hideFollowers
            customWarnings={warnings}
            readOnly={isReadOnly}
            {...rest}
        />
    );
};

export default BuyerChat;
